import { render, staticRenderFns } from "./MapaPagamentosDia.vue?vue&type=template&id=20c8faa0&scoped=true&"
import script from "./MapaPagamentosDia.vue?vue&type=script&lang=js&"
export * from "./MapaPagamentosDia.vue?vue&type=script&lang=js&"
import style0 from "./MapaPagamentosDia.vue?vue&type=style&index=0&id=20c8faa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8faa0",
  null
  
)

export default component.exports